import { Component } from 'react';
import styled from 'styled-components';
import { darken } from '../../utils/polished';
import { Icon } from '../Icon/Icon';

const ActionPanelElement = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.vars.newColor.lightGS1};
  border-radius: 5px;
  border: 1px solid #dce5eb;
  padding: 40px;
  flex: 1;

  &:hover {
    background-color: ${props => darken(0.01, props.theme.vars.newColor.lightGS1)};
    cursor: pointer;
  }

  &:active {
    background-color: ${props => darken(0.05, props.theme.vars.newColor.lightGS1)};
  }
`;

const ContentElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const IconCircle = styled.div`
  display: flex;
  width: 69px;
  height: 69px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f9fbfd;
  box-shadow: 2px 3px 4px 1px #c7c4c4;
`;

const LabelElement = styled.div`
  margin-top: 20px;
  font-size: 16px;
  color: #647079;
  font-weight: 600;
`;

interface IProps {
  /** Optional label to describe the action. */
  label?: string;
  /** Optional custom icon.  Defaults to 'plus'. */
  icon?: string;
  /** Event fired when the action panel is clicked */
  onClick?: () => void;
}

export class ActionPanel extends Component<IProps> {
  public render() {
    return (
      <ActionPanelElement onClick={this.props.onClick} data-testid="ActionPanel">
        <ContentElement>
          <IconCircle>
            <Icon color="#647079" icon={this.props.icon || 'plus'} size="extra-large" />
          </IconCircle>
          {this.props.label && <LabelElement>{this.props.label}</LabelElement>}
        </ContentElement>
      </ActionPanelElement>
    );
  }
}
